<template>
  <div ref="swiperBox"  class="swiperBox">
    <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" >
      <swiper-slide v-for="sliderImage in images" :key="sliderImage._id" >
          <img width ="80%" height="auto" :src="sliderImage.image" :alt="sliderImage.name" style="margin-left: auto;
  margin-right: auto;">
      </swiper-slide>
    </swiper>
  </div>

</template>

<script>
  import 'swiper/dist/css/swiper.min.css';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  export default{
    name:'Carousel',
    props:['images'],
    components: {
      swiper,
      swiperSlide,
    },
    data(){
      return {
        // Related Products Swiper
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 55,
          breakpoints: {
            1600: {
              slidesPerView: 1,
            },
            1300: {
              slidesPerView: 1,
              spaceBetween: 55,
            },
            900: {
              slidesPerView: 1,
              spaceBetween: 55,
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 55,
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      };
    },
  };
</script>

<style scoped>
  .swiperBox{
    width:100%;
    position: relative;
  }
  .swiper_btn{
    position: absolute;
  }
</style>
